export default import.meta.ROLLDOWN_FILE_URL_r29fIoosfGbGvimn5vx2pA